class KokoSetExperience {
  constructor(root) {
    this.root = root;
    this.items = [...root.querySelectorAll('.koko-set-reveal')];
    if (!this.items.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('is-reveal-ready');
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        this.observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    this.items.forEach((item) => this.observer.observe(item));
  }
}
document.querySelectorAll('[data-koko-set]').forEach((root) => new KokoSetExperience(root));
